module.exports = __webpack_public_path__ + "assets/img/icon-snatch.6f37e682.png";